export const QUESTION_OPTION_KEYS = [
    { id: 0, keys: ['a', 'b', 'c', 'd', 'e'] },
    { id: 1, keys: ['a', 'b', 'c', 'd'] },
    { id: 2, keys: ['a', 'b'] },
    { id: 3, keys: ['a', 'b', 'c', 'd'] },
    { id: 4, keys: ['a', 'b', 'c', 'd'] },
    { id: 5, keys: ['a', 'b', 'c', 'd'] },
    { id: 6, keys: ['a', 'b', 'c', 'd'] },
    { id: 7, keys: ['a', 'b', 'c', 'd'] },
    { id: 8, keys: ['a', 'b'] },
    { id: 9, keys: ['a', 'b', 'c', 'd'] },
    { id: 11, keys: ['a', 'b', 'c', 'd'] },
    { id: 12, keys: ['a', 'b', 'c', 'd'] },
    { id: 13, keys: ['a', 'b', 'c'] },
    { id: 14, keys: ['a', 'b', 'c', 'd'] },
    { id: 15, keys: ['a', 'b', 'c', 'd'] },
    { id: 16, keys: ['a', 'b', 'c', 'd'] },
    { id: 17, keys: ['a', 'b', 'c', 'd'] },
    { id: 18, keys: ['a', 'b', 'c', 'd'] },
    { id: 19, keys: ['a', 'b', 'c', 'd'] },
    { id: 22, keys: ['a', 'b', 'c', 'd'] },
    { id: 24, keys: ['a', 'b', 'c', 'd'] },
    { id: 25, keys: ['a', 'b', 'c', 'd'] },
    { id: 28, keys: ['a', 'b', 'c', 'd'] },
    { id: 29, keys: ['a', 'b'] },
    { id: 30, keys: ['a', 'b', 'c', 'd'] },
    { id: 31, keys: ['a', 'b', 'c'] },
    { id: 34, keys: ['a', 'b', 'c', 'd'] },
    { id: 35, keys: ['a', 'b', 'c', 'd'] },
    { id: 36, keys: ['a', 'b'] },
    { id: 37, keys: ['a', 'b', 'c', 'd'] },
    { id: 53, keys: ['a', 'b'] },
    { id: 60, keys: ['a', 'b', 'c', 'd'] },
    { id: 65, keys: ['a', 'b'] },
    { id: 67, keys: ['a', 'b'] },
    { id: 70, keys: ['a', 'b', 'c', 'd'] },
    { id: 72, keys: ['a', 'b', 'c', 'd'] },
    { id: 73, keys: ['a', 'b'] },
    { id: 74, keys: ['a', 'b', 'c', 'd'] },
    { id: 75, keys: ['a', 'b'] },
    { id: 76, keys: ['a', 'b'] },
    { id: 79, keys: ['a', 'b'] },
    { id: 84, keys: ['a', 'b', 'c', 'd'] },
    { id: 85, keys: ['a', 'b'] },
    { id: 86, keys: ['a', 'b', 'c', 'd'] },
    { id: 87, keys: ['a', 'b'] },
    { id: 88, keys: ['a', 'b', 'c', 'd'] },
    { id: 90, keys: ['a', 'b', 'c', 'd'] },
    { id: 91, keys: ['a', 'b'] },
    { id: 92, keys: ['a', 'b', 'c', 'd'] },
    { id: 96, keys: ['a', 'b', 'c', 'd'] },
    { id: 97, keys: ['a', 'b'] },
    { id: 98, keys: ['a', 'b', 'c', 'd'] },
    { id: 99, keys: ['a', 'b'] },
    { id: 100, keys: ['a', 'b', 'c'] },
    { id: 101, keys: ['a', 'b', 'c'] },
    { id: 102, keys: ['a', 'b', 'c', 'd'] },
    { id: 103, keys: ['a', 'b'] },
    { id: 104, keys: ['a', 'b', 'c', 'd'] },
    { id: 105, keys: ['a', 'b'] },
    { id: 106, keys: ['a', 'b'] },
    { id: 107, keys: ['a', 'b', 'c', 'd'] },
    { id: 108, keys: ['a', 'b'] },
    { id: 109, keys: ['a', 'b', 'c'] },
    { id: 110, keys: ['a', 'b'] },
    { id: 111, keys: ['a', 'b', 'c', 'd'] },
    { id: 112, keys: ['a', 'b', 'c', 'd'] },
    { id: 113, keys: ['a', 'b'] },
    { id: 114, keys: ['a', 'c'] },
    { id: 116, keys: ['a', 'b', 'c', 'd'] },
    { id: 117, keys: ['a', 'b'] },
    { id: 118, keys: ['a', 'b'] },
    { id: 120, keys: ['a', 'b', 'c'] },
    { id: 121, keys: ['a', 'b', 'c', 'd'] },
    { id: 122, keys: ['a', 'b'] },
    { id: 123, keys: ['a', 'b', 'c'] },
    { id: 124, keys: ['a', 'b'] },
    { id: 125, keys: ['a', 'b'] },
    { id: 126, keys: ['a', 'b', 'c'] },
    { id: 127, keys: ['a', 'b', 'c', 'd'] },
    { id: 128, keys: ['a', 'b', 'c', 'd', 'e', 'f'] },
    { id: 129, keys: ['a', 'b', 'c'] },
    { id: 130, keys: ['a', 'b', 'c', 'd', 'e'] },
    { id: 131, keys: ['a', 'b', 'c'] },
    { id: 132, keys: ['a', 'b'] },
    { id: 133, keys: ['a', 'b'] },
    { id: 135, keys: ['a', 'b'] },
    { id: 138, keys: ['a', 'b', 'c'] },
    { id: 139, keys: ['a', 'b'] },
    { id: 140, keys: ['a', 'b'] },
    { id: 141, keys: ['a', 'b'] },
    { id: 142, keys: ['a', 'b'] },
    { id: 143, keys: ['a', 'b'] },
];
//# sourceMappingURL=questions.js.map